import { ITheme } from '@fluentui/react';
import * as React from 'react';
import { ServiceRequestPageManager } from '../../../../web/common/components/ServiceRequestPageManager';
import { captureContentUpdate } from '../../../../web/utils/oneDsUtil';
import { AutomationIds } from '../../../models/constants/automationIds';
import { IContactUsStyles, getContactUsClassNames } from '../styles/contactUsStyles';
import { IStyledComponent } from '../styles/themesUI';
import { SignInButtonContainer } from '../containerComponents/SignInButtonContainer';

export interface RequestCreationTabViewProps {
  correlationId: string;
  isSignedIn: boolean;
}

interface IProps {
  theme?: ITheme;
}

type IRequestCreationTabViewProps = IProps & RequestCreationTabViewProps & IStyledComponent<IContactUsStyles>;

export class RequestCreationTabView extends React.Component<IRequestCreationTabViewProps> {
  public componentDidMount = () => {
    this.logRequestConfirmationTabLoad();
    window.scrollTo(0, 0);
  };

  public render = () => {
    const contactUsClassNames = getContactUsClassNames(this.props.styles, { theme: this.props.theme });
    return (
      <div data-automation-id={AutomationIds.RequestCreationContent} className={contactUsClassNames.requestCreationTab}>
        <ServiceRequestPageManager theme={this.props.theme} />
        {!this.props.isSignedIn && <SignInButtonContainer/>}
      </div>
    );
  };

  private logRequestConfirmationTabLoad = () => {
    const contentUpdateLog = {
      content: {
        contentId: 'RequestCreationTab',
        contentName: 'RequestCreationTabOpen',
        correlationId: this.props.correlationId,
        areaName: 'modalitiesSection',
        callerMethod: 'logRequestConfirmationTabLoad',
        formnm: 'maxFunnel',
      },
      behavior: 'CONTACT',
    };
    captureContentUpdate(contentUpdateLog);
  };
}
